import React, { useState, useEffect } from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddGallery(props) {
  return (
    <PostAdd
      targetVid={"gallery_categories"}
      addPostEndpoint={apiEndpoints.gallery}
      editRoute={"/galleries/edit"}
      entityType={"gallery"}
      pageTitle={"Create a gallery post"}
      returnRoute={"/galleries-creator"}
      extraBlocks={[
        {
          data: {
            images: [],
          },
          type: "gallery",
        },
      ]}
    />
  );
}
